import { isDev } from "@/constants/env";
import type { Axios } from "axios";
import axios from "axios";
import { createContext, useContext, useMemo } from "react";

const apiContext = createContext(
    null as null | {
        api: Axios;
    },
);

export const getBaseUrl = () => {
    if (isDev) {
        return "http://localhost:3003";
    }
    return location.origin;
};

export const ApiProvider = (props: { children: React.ReactNode }) => {
    const api = useMemo(() => {
        return axios.create({
            baseURL: getBaseUrl(),
        });
    }, []);
    return (
        <apiContext.Provider
            value={{
                api,
            }}
        >
            {props.children}
        </apiContext.Provider>
    );
};
export const useApi = ()=>{
    const api = useContext(apiContext); 
    if(!api){
        throw new Error("no api provider")
    }
    return api
}